import React from "react";

export const useScrollThreshold = (threshold?: number | null) => {
   const [isScrolled, setIsScrolled] = React.useState(false);

   const handleScroll = React.useCallback(() => {
      const percent = (document.documentElement['scrollTop'] || document.body['scrollTop']) / ((document.documentElement['scrollHeight'] || document.body['scrollHeight']) - document.documentElement.clientHeight) * 100;
      if (threshold !== null && threshold !== undefined && percent > threshold && !isScrolled) {
         setIsScrolled(true);
      }
      if (threshold !== null && threshold !== undefined && percent <= threshold && isScrolled) {
         setIsScrolled(false);
      }
   }, [isScrolled, threshold]);

   React.useEffect(() => {
      if (threshold !== null && threshold !== undefined) {
         window.addEventListener("scroll", handleScroll, { passive: true });
      }
      return () => {
         if (threshold !== null && threshold !== undefined) {
            window.removeEventListener("scroll", handleScroll);
         }
      };
   }, [handleScroll, threshold]);

   return isScrolled;
};